import * as angular from 'angular';

import { ComponentDefinition, Miniature } from '../../models';

class MiniaturesController implements angular.IComponentController {
    miniatures: Miniature[];
    selected: Miniature;
    disableExperimental: boolean;

    static $inject = [];
}

export const wtMiniatures: ComponentDefinition = {
    componentId: 'wtMiniatures',
    template: require('./miniatures.component.html'),
    controller: MiniaturesController,
    controllerAs: 'vm',
    bindings: {
        icons: '<?',
        disableExperimental: '<?',
        miniatures: '<',
        selected: '=?',
    }
};